import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/home/Home';
import LoanForm from './components/addloan/LoanForm';
import Layout from './components/layout/Layout';
import ExceptionPage from "./components/exceptionPage";
import NMLSVerification from './components/nmls/verification';
import TPOComment from './components/comment/tpocomment';
import LOSComment from './components/comment/losComment';
import CommercialLoanApplicationForm from './components/commercial/Index';
import CorrespondentAdditionalInfo from './components/commercial/CorrespondentAdditionalInfo';
import LoginSection from './components/newlogin/app/page';
import CreditRequest from './components/creditreport/CreditReportForm';
import DynamicMenu from './components/menu/SidebarMenu';
import ExceptionRequestForm from './components/requestform/exceptionrequest';
import Presubmissionform from './components/presubmission/presubmissionform';
import SendDisclosures from './components/validation/SendDisclosures';
import GuidelineExceptionForm from './components/requestform/guidelineexception';
import CustomHeader from './components/customheader/customheader';
import LoanSummary from './components/loansummary/index';
import SubmitLoan from './components/validation/SubmitLoan';
import PricingValidate from './components/validation/PricingValidate';
import OrderCreditValidate from './components/validation/OrderCreditValidate';
import Contact from './components/contactsupport/contactsupport';
import Resolve from './components/contactsupport/resolveComments';
import FeeValidate from './components/validation/FeeValidate';
import LockComparison from './components/lockcomparison/index';
import LoanchangeRequest from './components/changerequest/loanchangerequest';
import LoanchangeRequestUpdated from './components/changerequest/loanchangerequestupdated';
import LighteningOrder from './components/lighteningorder/placeorder';
import RequestDisclosures from './components/validation/RequestDisclosures';
import GuidelineExceptionValidate from './components/validation/GuidelineExceptionValidate';
import ChatConversation from './components/aichat/chatconversation';
import CashToCloseForm from './components/commercial/CashToClose';
import ContactUs from './components/menucontactus/contactus';

import FeeBreakdown from './components/feeBreakdown/FeeBreakdown';
import FeeBreakdownV2 from './components/feeBreakdown/FeeBreakdownV2';
import LicensingPage from './components/validation/LicensingPage';
import AppraisalValidate from './components/validation/AppraisalValidate';
import ConditionSnap from './components/loconditionsnapshot/loconditions';
import AdditionalInfoPage from './components/urla/AdditionalInfoPage';
import AILoanSummary from './components/aichat/ailoansummary';
import LoanComparison from './components/lockcomparison/loancomparison';
import ApprovalCertificatePage from './components/approvalcertificate/ApprovalCertificatePage';
import LoaderPage from "./components/common/LoaderPage";
import MilestoneValidationPage from "./components/pages/MilestoneValidationPage";
import MilestoneValidationUpdated from "./components/pages/MilestoneValidationUpdated";
import LoanApprovalMilestoneRuleExecutionPage from "./components/milestoneRuleExecution/LoanApprovalMilestoneRuleExecutionPage";
import LenderKeyContacts from "./components/lenderkeycontacts/lendercontacts";
import AssetDepletionPage from './components/assetdepletion/AssetDepletionPage';
import RequiredReservesPage from './components/requiredreserves/RequiredReservesPage';
import AMDocReview from './components/loamdocreview/amdocreview';
import AuditTrail from './components/audittrail/TimelineView';
import NewLoanForm from './components/loanchannel/NewLoanForm';
import CuReviewPage from "./components/cuReview/CuReviewPage";
import LenderCreditYsp from './components/lenderCreditYsp/LenderCreditYsp';
import UnifiedAdditionalInfo from "./components/common/UnifiedAdditionalInfo";
import Matrices from './components/guidelinematrices/matrices';
import MilestoneProcessingPage from "./components/common/MilestoneProcessingPage";
import CorrespondentForms from './components/correspondentForms/Forms';
import CorrespondentMatrices from './components/correspondentMatrices/correspondentmatrices';
import QuickPricer from './components/quickpricer/QuickPricer';
import CorrCertificatePage from './components/correspondentcertificate/CorrespondentCertificatePage';
import AIAgentView from './components/aiagentview/AIAgentView';
import RecommendedDocReview from './components/documentreview/recommendeddocreview';
import BrokerDocUpload from './components/brokerdocupload/BrokerDocUpload';
import Documents from './components/brokerdocupload/Documents';
import Conditions from './components/conditions/Conditions';
import ConditionUpdated from './components/conditions/conditionUpdated';
import ConditionsWeb from './components/web/conditions/conditions_web';
import LoanApproval from './components/loanapproval/LoanApprovalPage';
import LoginSwitcher from './components/login/LoginSwitcher';
import SkyTPOLogin from './components/login/skyTPOLogin';
import QuickPriceFormNew from './components/quickpricenew';
import AppraisalOrderPage from './components/appraisalorder/AppraisalOrderPage';
import LoanRuleExceptionManager from './components/exceptionrule/LoanRuleExceptionManager';
import DealDeskPage from './components/dealdesk/DealDeskPage';
import CancelLoan from './components/loansummary/cancelLoan';

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/skytpo-login" element={<SkyTPOLogin />} />
          <Route path="/login" element={<LoginSwitcher />} />
          <Route path="/loan" element={<LoanForm />} />
          <Route path="/loanchannels" element={<NewLoanForm />} />
          <Route path="/nmls" element={<NMLSVerification />} />
          <Route path="/exception" element={<ExceptionPage />} />
          <Route path="/tpocomment" element={<TPOComment />} />
          <Route path="/loscomment" element={<LOSComment />} />

          <Route path="/commercial-loan" element={<CommercialLoanApplicationForm />} />
          <Route path="/commercial-additional-info" element={<CorrespondentAdditionalInfo />} />
          <Route path="/cash-to-close" element={<CashToCloseForm />} />

          <Route path="/quickprice" element={<QuickPriceFormNew />} />
          <Route path="/CorrQuickPrice" element={<QuickPriceFormNew isCorrespondent={true} />} />
          <Route path="/loginnew" element={<LoginSection />} />
          <Route path="/creditrequest" element={<CreditRequest />} />
          <Route path="/loantype-menu" element={<DynamicMenu />} />
          <Route path="/exception-requestform" element={<ExceptionRequestForm />} />
          <Route path="/presubmissionform" element={<Presubmissionform />} />
          <Route path="/validate-disclosures" element={<SendDisclosures />} />
          <Route path="/validate-request-disclosures" element={<RequestDisclosures />} />
          <Route path="/guideline-exception" element={<GuidelineExceptionForm />} />
          <Route path="/loansummary" element={<LoanSummary />} />
          <Route path="/cancel-loan" element={<LoanSummary isPageCancelLoan={true} />} />
          <Route path="/cancel-loan-web" element={<CancelLoan isWeb={true} />} />
          <Route path="/custom-header" element={<CustomHeader />} />
          <Route path="/validate-submitloan" element={<SubmitLoan />} />
          <Route path="/contact-support" element={<Contact />} />
          <Route path="/validate-pricing" element={<PricingValidate />} />
          <Route path="/validate-credit" element={<OrderCreditValidate />} />
          <Route path="/resolve-comments" element={<Resolve />} />
          <Route path="/validate-fee" element={<FeeValidate />} />
          <Route path="/lockcomparison" element={<LockComparison />} />
          <Route path="/loancomparison" element={<LoanComparison />} />
          <Route path="/change-request" element={<LoanchangeRequest />} />
          <Route path="/change-request-updated" element={<LoanchangeRequestUpdated />} />
          <Route path="/audit-trail" element={<AuditTrail />} />
          <Route path="/lightening-order" element={<LighteningOrder />} />
          <Route path="/guideline-chat" element={<ChatConversation />} />
          <Route path="/ai-loansummary" element={<AILoanSummary />} />

          <Route path="/fee-breakdown" element={<FeeBreakdown />} />
          <Route path="/fee-breakdown-v2" element={<FeeBreakdownV2 />} />
          <Route path="/licensing" element={<LicensingPage />} />
          <Route path="/validate-appraisal" element={<AppraisalValidate />} />
          <Route path="/validate-guideline-exception" element={<GuidelineExceptionValidate />} />
          <Route path="/loan-conditionsnap" element={<ConditionSnap />} />
          <Route path="/urla/additional-info" element={<AdditionalInfoPage />} />
          <Route path="/approval-certificate" element={<ApprovalCertificatePage />} />
          <Route path="/milestone-validation" element={<MilestoneValidationPage />} />
          <Route path="/milestone-validation-updated" element={<MilestoneValidationUpdated />} />
          <Route path="/milestone-rule-execution" element={<LoanApprovalMilestoneRuleExecutionPage />} />
          <Route path="/loader" element={<LoaderPage />} />
          <Route path="/lendercontacts" element={<LenderKeyContacts />} />

          <Route path="/asset-depletion" element={<AssetDepletionPage />} />
          <Route path="/required-reserves" element={<RequiredReservesPage />} />
          <Route path="/amdocreview" element={<AMDocReview />} />

          <Route path="/cu-review" element={<CuReviewPage />} />

          <Route path="/lender-credit-ysp" element={<LenderCreditYsp />} />
          <Route path="/additional-info" element={<UnifiedAdditionalInfo />} />
          <Route path="/guideline-matrices" element={<Matrices />} />
          <Route path="/milestone-processing" element={<MilestoneProcessingPage />} />

          <Route path="/correspondent-forms" element={<CorrespondentForms />} />
          <Route path="/correspondent-matrices" element={<CorrespondentMatrices />} />
          <Route path="/quick-pricer" element={<QuickPricer />} />

          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/correspondent-certificate" element={<CorrCertificatePage />} />
          <Route path="/ai-agent-view" element={<AIAgentView />} />
          <Route path="/recommended-doc-review" element={<RecommendedDocReview />} />
          <Route path="/broker-doc-upload" element={<BrokerDocUpload />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/conditions" element={<Conditions />} />
          <Route path="/conditions-updated" element={<ConditionUpdated />} />
          <Route path="/conditions-web" element={<ConditionsWeb />} />
          <Route path="/loan-approval" element={<LoanApproval />} />
          <Route path="/appraisal-order" element={<AppraisalOrderPage />} />
          <Route path="/exception-rule-manager" element={<LoanRuleExceptionManager />} />
          <Route path="/deal-desk" element={<DealDeskPage />} />

          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
